/**
 * "Reference" documentation section (ADR-0074).
 *
 * A consolidated lookup hub: an overview that points at every reference-style
 * resource across the docs (CLI reference, MCP reference, framework support,
 * glossary, languages), plus two cross-cutting quick-reference pages — the key,
 * token, and ID formats, and the platform limits and defaults. It links to the
 * pages that own each topic rather than restating them.
 */
import { REFERENCE_KEY_FORMATS_PAGE } from './pages/reference-key-formats.page';
import { REFERENCE_LIMITS_PAGE } from './pages/reference-limits.page';
import { REFERENCE_OVERVIEW_PAGE } from './pages/reference-overview.page';
import { REFERENCE_RUNTIME_API_PAGE } from './pages/reference-runtime-api.page';

import type { DocSection } from './types';

export const REFERENCE_SECTION: DocSection = {
  id: 'reference',
  titleKey: 'docs.section.reference.title',
  pages: [
    REFERENCE_OVERVIEW_PAGE,
    REFERENCE_KEY_FORMATS_PAGE,
    REFERENCE_LIMITS_PAGE,
    REFERENCE_RUNTIME_API_PAGE,
  ],
};
